import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { QuoteStatusModel } from 'src/app/core/model/quote-status-model';
import { RecordPickupModalComponent } from 'src/app/shared/components/record-pickup-modal/record-pickup-modal.component';
import InventoryManagementService from '../inventory-unpublished-batch/inventory-management.service';
import { ToastService } from 'src/app/core/services/toaster.service';
import { NgIf, NgFor, NgClass, DecimalPipe, TitleCasePipe, CurrencyPipe } from '@angular/common';
import { QuoteStatusStylePipe } from '../../../shared/pipes/quote-status-style-pipe';

@Component({
    selector: 'app-custom-inventory-details-content',
    templateUrl: './custom-inventory-details-content.component.html',
    styleUrls: ['./custom-inventory-details-content.component.scss'],
    imports: [NgIf, NgFor, NgClass, DecimalPipe, TitleCasePipe, CurrencyPipe, QuoteStatusStylePipe]
})
export class CustomInventoryDetailsContentComponent implements OnInit {

  @Input('Data') inventoryDetailsPagesData: any;
  @Input('tabName') tabName: any;

  quoteStatusModel = new QuoteStatusModel();
  showPlacedBidmsg: boolean;
  showExpireTime: boolean = true;
  constructor(public modalService:NgbModal, private inventoryManagementService: InventoryManagementService, private toastService: ToastService) { }

  ngOnInit(): void {
    if(this.inventoryDetailsPagesData && this.inventoryDetailsPagesData.length>0){
      // inventory details page data
    }
  }
  expiresTime(i){
    if(this.inventoryDetailsPagesData[i] && this.inventoryDetailsPagesData[i].validity){
    // if(data && data.validity){
      let data = this.inventoryDetailsPagesData[i];
      let validTime = moment(data.validity);
      let currentTime = moment();
      let duration = validTime.diff(currentTime);
      if(duration > 0){
        this.showExpireTime = true;
        let tempTime = moment.duration(duration);
        let durationDays = tempTime.days()+ "d";
        let durationHours = tempTime.hours() + "h";
        let durationMins = tempTime.minutes()+ "m";
        if(tempTime.days() > 0){
          let durationTime = '';
          return durationTime;
        }
        else{
          // let durationTime = "Expiring in" + " " +durationDays + " " + durationHours + " " + durationMins;
          let durationTime = "Expiring in" + " " + durationHours + " " + durationMins;
          return durationTime;
        }
      }else{
       // return this.showExpireTime = false;
      }
    }else{
      return this.showExpireTime = false;
    }
  }
  convertDateOnly(dateString): any {
    if (dateString) {
      // return moment.utc(dateString).local().format('YY/MM/DD');
      return moment(dateString).format('YYYY/MM/DD');
      return dateString
      // return moment(dateString).utcOffset('-06:00').format('YY/MM/DD')
    }
  }
  convertDateAndTime(dateString): any {
    if (dateString) {
    //  const momentObj = moment(dateString);
      // return moment.utc(dateString).local().format('YY/MM/DD HH:mm');
      // return moment(dateString).format('YY/MM/DD HH:mm');
      // return new Date(dateString);
      // return moment(dateString).format('YY/MM/DD HH:mm')
      // return moment(dateString).utcOffset('GMT+05:30').format('YY/MM/DD HH:mm')
      return moment.utc(dateString).local().format('YYYY/MM/DD HH:mm');
    }
  }
  respondToBid(index: any){
    const bidUrl = this.inventoryDetailsPagesData[index].respondToBidURL ? this.inventoryDetailsPagesData[index].respondToBidURL : "https://my340978.crm.ondemand.com/";
    window.open(bidUrl, "_blank");
  }
  recordPickup(index: any, data: any){
    // const batchId = data.PLbatch;
    // const contractNumber = data.CTContract;
    const batchId = data.batchNumber;
    const contractNumber = data.contractNumber;
   this.inventoryManagementService.getRecordPickupDetails(batchId,contractNumber).subscribe((pickupdata: any)=>{
      const modalRef = this.modalService.open(RecordPickupModalComponent, {centered: true, size: 'sm'});
      modalRef.componentInstance.recordData = pickupdata;
      // modalRef.componentInstance.recordData = "sample";
      modalRef.componentInstance.quoteData = this.inventoryDetailsPagesData[index];
   },(err: any)=>{
     console.log("err", err);
     this.toastService.show(err.error.errors[0] ? err.error.errors[0].message : "Something went wrong!");
   })
  }
  getTimeDifference(time: any): any{
    let currentTime = new Date();
    var duration = moment.duration(time.diff(currentTime));
    var hours = duration.asHours();
  }
}
